import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function MetaPixelPageView() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // The shared script deduplicates the initial load and StrictMode effects.
    window.bybTrackPageView?.();
  }, [pathname, search]);

  return null;
}
